import React, { useEffect, useRef, useState } from 'react';

const ASSET_PATH = '/images';

export function AppSelectionSheet({ isVisible, onClose, onSelectApp, apps, selectedPlatform }) {
    const sheetRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [startY, setStartY] = useState(null);
    const [currentY, setCurrentY] = useState(null);

    // Фильтруем приложения для текущей платформы
    const filteredApps = apps.filter(app => app.platforms.includes(selectedPlatform));
    const displayApps = filteredApps.length > 0 ? filteredApps : apps;

    useEffect(() => {
        if (isVisible) {
            setIsOpen(true);
            document.body.style.overflow = 'hidden';
            document.body.classList.add('sheet-open');
        } else {
            setIsOpen(false);
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        }

        return () => {
            document.body.style.overflow = '';
            document.body.classList.remove('sheet-open');
        };
    }, [isVisible]);

    // Обработчики для свайпа
    const handleTouchStart = (e) => {
        setStartY(e.touches[0].clientY);
    };

    const handleTouchMove = (e) => {
        if (startY === null || !sheetRef.current) return;

        const currentTouchY = e.touches[0].clientY;
        const diff = currentTouchY - startY;

        if (diff > 0) {
            e.preventDefault();
            setCurrentY(diff);
            sheetRef.current.style.transform = `translateY(${diff}px)`;
        }
    };

    const handleTouchEnd = () => {
        if (startY === null) return;

        const diff = currentY || 0;

        if (diff > 100) {
            handleClose();
        } else {
            if (sheetRef.current) {
                sheetRef.current.style.transform = '';
            }
        }

        setStartY(null);
        setCurrentY(null);
    };

    // Обработчики для мыши
    const handleMouseDown = (e) => {
        setStartY(e.clientY);

        const handleMouseMove = (e) => {
            if (startY === null || !sheetRef.current) return;

            const diff = e.clientY - startY;

            if (diff > 0) {
                setCurrentY(diff);
                sheetRef.current.style.transform = `translateY(${diff}px)`;
            }
        };

        const handleMouseUp = () => {
            const diff = currentY || 0;

            if (diff > 100) {
                handleClose();
            } else {
                if (sheetRef.current) {
                    sheetRef.current.style.transform = '';
                }
            }

            setStartY(null);
            setCurrentY(null);

            document.removeEventListener('mousemove', handleMouseMove);
            document.removeEventListener('mouseup', handleMouseUp);
        };

        document.addEventListener('mousemove', handleMouseMove);
        document.addEventListener('mouseup', handleMouseUp);
    };

    const handleClose = () => {
        setIsOpen(false);
        setTimeout(() => {
            onClose();
        }, 300);
    };

    const handleAppSelect = (app) => {
        onSelectApp(app);
        handleClose();
    };

    const handleWheel = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    if (!isVisible) return null;

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            zIndex: 100000,
            pointerEvents: 'none',
            overflow: 'hidden'
        }}>
            {/* Затемнение */}
            <div style={{
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.7)',
                backdropFilter: 'blur(3px)',
                opacity: isOpen ? 1 : 0,
                transition: 'opacity 0.3s ease',
                pointerEvents: isOpen ? 'auto' : 'none',
            }} onClick={handleClose} />

            {/* Шторка */}
            <div
                ref={sheetRef}
                style={{
                    position: 'absolute',
                    bottom: 0,
                    left: 0,
                    right: 0,
                    backgroundColor: '#0b1217',
                    borderTopLeftRadius: '32px',
                    borderTopRightRadius: '32px',
                    boxShadow: '0 -4px 30px rgba(0, 0, 0, 0.5)',
                    pointerEvents: 'auto',
                    transform: isOpen ? 'translateY(0)' : 'translateY(100%)',
                    transition: currentY ? 'none' : 'transform 0.4s cubic-bezier(0.16, 1, 0.3, 1)',
                    maxHeight: '100vh',
                    overflow: 'hidden',
                }}
                onWheel={handleWheel}
                className='sheet-selection'
            >
                {/* Фоновый вектор */}
                <img
                    src={`${ASSET_PATH}/0_596.svg`}
                    alt=""
                    style={{
                        position: 'absolute',
                        left: '-93px',
                        top: '151px',
                        width: '776px',
                        height: '929px',
                        zIndex: 0,
                        pointerEvents: 'none',
                        opacity: 0.5,
                    }}
                />

                <div
                    style={{
                        position: 'relative',
                        zIndex: 1,
                        maxWidth: '386px',
                        margin: '0 auto',
                        padding: '16px 16px 24px 16px',
                        overflowY: 'auto',
                        maxHeight: '100vh',
                    }}
                >
                    {/* Ползунок для закрытия */}
                    <div
                        style={{
                            width: '100%',
                            display: 'flex',
                            justifyContent: 'center',
                            padding: '8px 0 16px 0',
                            cursor: 'grab',
                            touchAction: 'none',
                            userSelect: 'none',
                        }}
                        onTouchStart={handleTouchStart}
                        onTouchMove={handleTouchMove}
                        onTouchEnd={handleTouchEnd}
                        onMouseDown={handleMouseDown}
                    >
                        <div style={{
                            width: '40px',
                            height: '4px',
                            backgroundColor: 'rgba(255, 255, 255, 0.2)',
                            borderRadius: '2px',
                        }} />
                    </div>

                    {/* Заголовок */}
                    <h2 style={{
                        color: 'white',
                        fontSize: '18px',
                        fontWeight: 600,
                        textAlign: 'center',
                        marginBottom: '24px'
                    }}>
                        Выберите приложение для установки
                    </h2>

                    {/* Список приложений */}
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', paddingBottom: '20px' }}>
                        {displayApps.map(app => (
                            <div
                                key={app.id}
                                onClick={() => handleAppSelect(app)}
                                style={{
                                    backgroundColor: 'rgba(200, 255, 227, 0.1)',
                                    backdropFilter: 'blur(1px)',
                                    borderRadius: '24px',
                                    padding: '12px 8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '16px',
                                    cursor: 'pointer',
                                    transition: 'background-color 0.2s',
                                }}
                                onMouseEnter={(e) => e.currentTarget.style.backgroundColor = 'rgba(200, 255, 227, 0.15)'}
                                onMouseLeave={(e) => e.currentTarget.style.backgroundColor = 'rgba(200, 255, 227, 0.1)'}
                            >
                                <div style={{
                                    width: '48px',
                                    height: '48px',
                                    flexShrink: 0,
                                    display: 'flex',
                                    justifyContent: 'center',
                                    alignItems: 'center',
                                }}>
                                    <img
                                        src={`${ASSET_PATH}/${app.icon}`}
                                        alt={app.name}
                                        style={{
                                            width: '100%',
                                            height: '100%',
                                            objectFit: 'contain',
                                            borderRadius: '16px',
                                        }}
                                    />
                                </div>
                                <div style={{ display: 'flex', flexDirection: 'column', gap: '4px' }}>
                                    <span style={{ color: '#ffffff', fontSize: '16px', fontWeight: 500 }}>{app.name}</span>
                                    <span style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: '12px' }}>
                                        Нажмите для установки
                                    </span>
                                </div>
                                <div style={{ marginLeft: 'auto' }}>
                                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9 18L15 12L9 6" stroke="rgba(255,255,255,0.4)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                    </svg>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}